/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import { Layer } from 'react-konva';
import PropTypes from 'prop-types';

import { shapeIdEnum } from '../../../../../enums';
import Stage from '../../Stage';
import Rectangle from '../../Rectangle';
import Circle from '../../Circle';
// import Line from '../../Line';
import Image from '../../Image';
import Polygon from '../../Polygon';
import sofaImg from '../../../../../assets/images/TMS/sofa.png';
import doorImg from '../../../../../assets/images/TMS/door.png';
import aquariumImg from '../../../../../assets/images/TMS/aquarium.png';
import paintingImg from '../../../../../assets/images/TMS/painting.png';
import windowImg from '../../../../../assets/images/TMS/window.png';
import restroomImg from '../../../../../assets/images/TMS/restroom.png';
import kitchenImg from '../../../../../assets/images/TMS/Kitchen.png';
import chairImg from '../../../../../assets/images/TMS/chair.png';
import {
  Table_1_Rect_0Deg,
  Table_1_Rect_45Deg,
  Table_1_Rect_90Deg,
  Table_1_Rect_135Deg,
  Table_1_Rect_180Deg,
  Table_1_Rect_225Deg,
  Table_1_Rect_270Deg,
  Table_1_Rect_315Deg,
  Table_1_Circle_0Deg,
  Table_1_Circle_45Deg,
  Table_1_Circle_90Deg,
  Table_1_Circle_135Deg,
  Table_1_Circle_180Deg,
  Table_1_Circle_225Deg,
  Table_1_Circle_270Deg,
  Table_1_Circle_315Deg,
  Table_2_Rect_1_1_0Deg,
  Table_2_Rect_1_1_45Deg,
  Table_2_Rect_1_1_90Deg,
  Table_2_Rect_1_1_135Deg,
  Table_2_Circle_0Deg,
  Table_2_Circle_45Deg,
  Table_2_Circle_90Deg,
  Table_2_Circle_135Deg,
  Table_4_Rect_1_1_1_1_0Deg,
  Table_4_Rect_1_1_1_1_45Deg,
  Table_4_Rect_2_2_0Deg,
  Table_4_Rect_2_2_45Deg,
  Table_4_Rect_2_2_90Deg,
  Table_4_Rect_2_2_135Deg,
  Table_4_Circle_0Deg,
  Table_4_Circle_45Deg,
  Table_6_Rect_1_2_1_2_0Deg,
  Table_6_Rect_1_2_1_2_45Deg,
  Table_6_Rect_1_2_1_2_90Deg,
  Table_6_Rect_1_2_1_2_135Deg,
  Table_6_Rect_3_3_0Deg,
  Table_6_Rect_3_3_45Deg,
  Table_6_Rect_3_3_90Deg,
  Table_6_Rect_3_3_135Deg,
  Table_6_Circle,
  Table_8_Rect_4_4_0Deg,
  Table_8_Rect_4_4_45Deg,
  Table_8_Rect_4_4_90Deg,
  Table_8_Rect_4_4_135Deg,
  Table_8_Rect_2_2_2_2_0Deg,
  Table_8_Rect_2_2_2_2_45Deg,
  Table_8_Rect_1_3_1_3_0Deg,
  Table_8_Rect_1_3_1_3_45Deg,
  Table_8_Rect_1_3_1_3_90Deg,
  Table_8_Rect_1_3_1_3_135Deg,
  Table_8_Circle,
  Table_10_Rect_1_4_1_4_0Deg,
  Table_10_Rect_1_4_1_4_45Deg,
  Table_10_Rect_1_4_1_4_90Deg,
  Table_10_Rect_1_4_1_4_135Deg,
  Table_10_Rect_2_3_2_3_0Deg,
  Table_10_Rect_2_3_2_3_45Deg,
  Table_10_Rect_2_3_2_3_90Deg,
  Table_10_Rect_2_3_2_3_135Deg,
  Table_10_Rect_5_5_0Deg,
  Table_10_Rect_5_5_45Deg,
  Table_10_Rect_5_5_90Deg,
  Table_10_Rect_5_5_135Deg,
  Table_10_Circle,
} from '../../Tables';

const Whiteboard = (props) => {
  const {
    onChangeShape,
    selectShape,
    onStageClicked,
    draggable,
    shapes,
    selectedShape,
    backgroundColor,
    stageContainerBackgroundColor,
    tableInfoColumn,
    keyName1,
    keyName2_primary,
    keyName2_secondary,
    keyName3,
    height,
  } = props;
  const shapesArray = shapes instanceof Map
    ? Array.from(shapes.values())
    : Array.isArray(shapes)
      ? shapes
      : [];

  const drawShape = shapeProps => {
    const staticShape = getImage(shapeProps?.shapeId);
    if (staticShape) {
      return (
        <Image
          key={shapeProps?.id}
          src={staticShape}
          shapeProps={shapeProps}
          isSelected={shapeProps?.id === selectedShape?.id}
          onSelect={() => selectShape && selectShape(shapeProps)}
          onChange={updatedShape => onChangeShape && onChangeShape(updatedShape)}
          draggable={draggable}
        />
      );
    }

    const ShapeComponent = getComponent(shapeProps?.shapeId);
    if (!ShapeComponent) return null;
    return (
      <ShapeComponent
        key={shapeProps?.id}
        shapeProps={shapeProps}
        isSelected={shapeProps?.id === selectedShape?.id}
        onSelect={() => {
          selectShape && selectShape(shapeProps)
        }}
        onChange={updatedShape => onChangeShape && onChangeShape(updatedShape)}
        draggable={draggable}
        tableInfoColumn={tableInfoColumn}
        keyName1={keyName1}
        keyName2={shapeProps?.showClosedTime ? keyName2_primary : keyName2_secondary}
        keyName3={keyName3}
      />
    );
  };

  const getImage = shapeId => {
    switch (shapeId) {
      case shapeIdEnum.DOOR_IMG: return doorImg;
      case shapeIdEnum.SOFA_IMG: return sofaImg;
      case shapeIdEnum.WINDOW_IMG: return windowImg;
      case shapeIdEnum.AQUARIUM_IMG: return aquariumImg;
      case shapeIdEnum.PAINTING_IMG: return paintingImg;
      case shapeIdEnum.CHAIR_IMG: return chairImg;
      case shapeIdEnum.RESTROOM_IMG: return restroomImg;
      case shapeIdEnum.KITCHEN_IMG: return kitchenImg;
      default: return null;
    }
  }

  const getComponent = shapeId => {
    switch (shapeId) {
      case shapeIdEnum.RECTANGLE:
      case shapeIdEnum.SQUARE: return Rectangle;
      case shapeIdEnum.CIRCLE: return Circle;
      case shapeIdEnum.POLYGON: return Polygon;
      case shapeIdEnum.TABLE_1_RECT_0DEG: return Table_1_Rect_0Deg;
      case shapeIdEnum.TABLE_1_RECT_45DEG: return Table_1_Rect_45Deg;
      case shapeIdEnum.TABLE_1_RECT_90DEG: return Table_1_Rect_90Deg;
      case shapeIdEnum.TABLE_1_RECT_135DEG: return Table_1_Rect_135Deg;
      case shapeIdEnum.TABLE_1_RECT_180DEG: return Table_1_Rect_180Deg;
      case shapeIdEnum.TABLE_1_RECT_225DEG: return Table_1_Rect_225Deg;
      case shapeIdEnum.TABLE_1_RECT_270DEG: return Table_1_Rect_270Deg;
      case shapeIdEnum.TABLE_1_RECT_315DEG: return Table_1_Rect_315Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_0DEG: return Table_1_Circle_0Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_45DEG: return Table_1_Circle_45Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_90DEG: return Table_1_Circle_90Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_135DEG: return Table_1_Circle_135Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_180DEG: return Table_1_Circle_180Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_225DEG: return Table_1_Circle_225Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_270DEG: return Table_1_Circle_270Deg;
      case shapeIdEnum.TABLE_1_CIRCLE_315DEG: return Table_1_Circle_315Deg;
      case shapeIdEnum.TABLE_2_RECT_1_1_0DEG: return Table_2_Rect_1_1_0Deg;
      case shapeIdEnum.TABLE_2_RECT_1_1_45DEG: return Table_2_Rect_1_1_45Deg;
      case shapeIdEnum.TABLE_2_RECT_1_1_90DEG: return Table_2_Rect_1_1_90Deg;
      case shapeIdEnum.TABLE_2_RECT_1_1_135DEG: return Table_2_Rect_1_1_135Deg;
      case shapeIdEnum.TABLE_2_CIRCLE_0DEG: return Table_2_Circle_0Deg;
      case shapeIdEnum.TABLE_2_CIRCLE_45DEG: return Table_2_Circle_45Deg;
      case shapeIdEnum.TABLE_2_CIRCLE_90DEG: return Table_2_Circle_90Deg;
      case shapeIdEnum.TABLE_2_CIRCLE_135DEG: return Table_2_Circle_135Deg;
      case shapeIdEnum.TABLE_4_RECT_1_1_1_1_0DEG: return Table_4_Rect_1_1_1_1_0Deg;
      case shapeIdEnum.TABLE_4_RECT_1_1_1_1_45DEG: return Table_4_Rect_1_1_1_1_45Deg;
      case shapeIdEnum.TABLE_4_RECT_2_2_0DEG: return Table_4_Rect_2_2_0Deg;
      case shapeIdEnum.TABLE_4_RECT_2_2_45DEG: return Table_4_Rect_2_2_45Deg;
      case shapeIdEnum.TABLE_4_RECT_2_2_90DEG: return Table_4_Rect_2_2_90Deg;
      case shapeIdEnum.TABLE_4_RECT_2_2_135DEG: return Table_4_Rect_2_2_135Deg;
      case shapeIdEnum.TABLE_4_CIRCLE_0DEG: return Table_4_Circle_0Deg;
      case shapeIdEnum.TABLE_4_CIRCLE_45DEG: return Table_4_Circle_45Deg;
      case shapeIdEnum.TABLE_6_RECT_3_3_0DEG: return Table_6_Rect_3_3_0Deg;
      case shapeIdEnum.TABLE_6_RECT_3_3_45DEG: return Table_6_Rect_3_3_45Deg;
      case shapeIdEnum.TABLE_6_RECT_3_3_90DEG: return Table_6_Rect_3_3_90Deg;
      case shapeIdEnum.TABLE_6_RECT_3_3_135DEG: return Table_6_Rect_3_3_135Deg;
      case shapeIdEnum.TABLE_6_RECT_1_2_1_2_0DEG: return Table_6_Rect_1_2_1_2_0Deg;
      case shapeIdEnum.TABLE_6_RECT_1_2_1_2_45DEG: return Table_6_Rect_1_2_1_2_45Deg;
      case shapeIdEnum.TABLE_6_RECT_1_2_1_2_90DEG: return Table_6_Rect_1_2_1_2_90Deg;
      case shapeIdEnum.TABLE_6_RECT_1_2_1_2_135DEG: return Table_6_Rect_1_2_1_2_135Deg;
      case shapeIdEnum.TABLE_6_CIRCLE: return Table_6_Circle;
      case shapeIdEnum.TABLE_8_RECT_4_4_0DEG: return Table_8_Rect_4_4_0Deg;
      case shapeIdEnum.TABLE_8_RECT_4_4_45DEG: return Table_8_Rect_4_4_45Deg;
      case shapeIdEnum.TABLE_8_RECT_4_4_90DEG: return Table_8_Rect_4_4_90Deg;
      case shapeIdEnum.TABLE_8_RECT_4_4_135DEG: return Table_8_Rect_4_4_135Deg;
      case shapeIdEnum.TABLE_8_RECT_2_2_2_2_0DEG: return Table_8_Rect_2_2_2_2_0Deg;
      case shapeIdEnum.TABLE_8_RECT_2_2_2_2_45DEG: return Table_8_Rect_2_2_2_2_45Deg;
      case shapeIdEnum.TABLE_8_RECT_1_3_1_3_0DEG: return Table_8_Rect_1_3_1_3_0Deg;
      case shapeIdEnum.TABLE_8_RECT_1_3_1_3_45DEG: return Table_8_Rect_1_3_1_3_45Deg;
      case shapeIdEnum.TABLE_8_RECT_1_3_1_3_90DEG: return Table_8_Rect_1_3_1_3_90Deg;
      case shapeIdEnum.TABLE_8_RECT_1_3_1_3_135DEG: return Table_8_Rect_1_3_1_3_135Deg;
      case shapeIdEnum.TABLE_8_CIRCLE: return Table_8_Circle;
      case shapeIdEnum.TABLE_10_RECT_1_4_1_4_0DEG: return Table_10_Rect_1_4_1_4_0Deg;
      case shapeIdEnum.TABLE_10_RECT_1_4_1_4_45DEG: return Table_10_Rect_1_4_1_4_45Deg;
      case shapeIdEnum.TABLE_10_RECT_1_4_1_4_90DEG: return Table_10_Rect_1_4_1_4_90Deg;
      case shapeIdEnum.TABLE_10_RECT_1_4_1_4_135DEG: return Table_10_Rect_1_4_1_4_135Deg;
      case shapeIdEnum.TABLE_10_RECT_2_3_2_3_0DEG: return Table_10_Rect_2_3_2_3_0Deg;
      case shapeIdEnum.TABLE_10_RECT_2_3_2_3_45DEG: return Table_10_Rect_2_3_2_3_45Deg;
      case shapeIdEnum.TABLE_10_RECT_2_3_2_3_90DEG: return Table_10_Rect_2_3_2_3_90Deg;
      case shapeIdEnum.TABLE_10_RECT_2_3_2_3_135DEG: return Table_10_Rect_2_3_2_3_135Deg;
      case shapeIdEnum.TABLE_10_RECT_5_5_0DEG: return Table_10_Rect_5_5_0Deg;
      case shapeIdEnum.TABLE_10_RECT_5_5_45DEG: return Table_10_Rect_5_5_45Deg;
      case shapeIdEnum.TABLE_10_RECT_5_5_90DEG: return Table_10_Rect_5_5_90Deg;
      case shapeIdEnum.TABLE_10_RECT_5_5_135DEG: return Table_10_Rect_5_5_135Deg;
      case shapeIdEnum.TABLE_10_CIRCLE: return Table_10_Circle;
      default: return null;
    }
  };

  return (
    <Stage
      onTap={onStageClicked}
      onMouseDown={onStageClicked}
      backgroundColor={backgroundColor}
      stageContainerBackgroundColor={stageContainerBackgroundColor}
      height={height}
    >
      <Layer>
        {shapesArray.map(shape => drawShape(shape))}
      </Layer>
    </Stage>
  );
};

export default Whiteboard;

Whiteboard.propTypes = {
  onChangeShape: PropTypes.func,
  selectShape: PropTypes.func,
  onStageClicked: PropTypes.func,
  draggable: PropTypes.bool,
  shapes: PropTypes.any,
  selectedShape: PropTypes.object,
  backgroundColor: PropTypes.string,
  stageContainerBackgroundColor: PropTypes.string,
};

Whiteboard.defaultProps = {
  onChangeShape: () => { },
  selectShape: () => { },
  onStageClicked: () => { },
  draggable: true,
  shapes: new Map(),
  selectedShape: {},
  backgroundColor: '#2a2a2a',
  stageContainerBackgroundColor: '#2a2a2a',
};
